// react imports
import { UseFormRegisterReturn } from "react-hook-form";

// common imports
import CheckIcon from "common/svg/CheckIcon";

// styled-components imports
import Checkbox from "./styled-components/Checkbox";
import CheckboxInput from "./styled-components/CheckboxInput";
import Container from "./styled-components/Container";
import Label from "./styled-components/Label";

interface TermsConfirmationProps {
  registerReturn: UseFormRegisterReturn;
}

function TermsConfirmation({ registerReturn }: TermsConfirmationProps) {
  return (
    <Container>
      <Checkbox>
        <CheckboxInput
          id={registerReturn.name}
          type="checkbox"
          {...registerReturn}
        />
        <CheckIcon />
      </Checkbox>
      <Label htmlFor={registerReturn.name}>Términos y condiciones</Label>
    </Container>
  );
}

export default TermsConfirmation;
